import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type FacebookWhiteProps = React.HTMLAttributes<HTMLDivElement> & {};

export const FacebookWhite: React.FC<FacebookWhiteProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/facebook-white.svg"} alt="" />
    </div>
  );
};